<template>
    <div>
      <modal name="estatus-importacion" :width="500" :height="'auto'" :clickToClose="false" :scrollable="true">
        <div class="modal-content modalContent">
          <span class="closebtn" @click="closeModal">&times;</span>
          <div class="text-center mt-4">
            <h3 class="with-lines">Status de la Importación</h3>
          </div>
          <div class="container text-center">
            <h6>¿Desea cambiar el status de la importación?</h6>
            <div class="">
              <select @change="updateStatus" v-model="localStatus" class="form-select form-select-sm" aria-label="Default select example">
                <option value="" selected disabled>Selecciona</option>
                <option v-for="(tipo, i) in tipoStatus" :key="i" :value="tipo.IdEstatusInd">
                  {{ tipo.Descripcion }}
                </option>
              </select>
            </div>
            <hr>
            <div class="mt-2 mb-3" v-if="localStatus == '2' || localStatus == '5' || localStatus == '7' || localStatus == '3'">
              <label for="exampleInputEmail1" class="form-label">Correo destinatario:</label>
              <input type="email" v-model="localEmail" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" @input="updateEmail">
            </div>
            <div v-if="localStatus == '5' || localStatus == '3'" class="mb-3 mt-3">
              <textarea v-model="localComentarios" placeholder="Describe el motivo" class="form-control" id="exampleFormControlTextarea1" rows="3" @input="updateComentarios"></textarea>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <button class="btn btn-blue col-5" @click="updateStatusImp">
                <i class="fas fa-paper-plane mr-1"></i>
                Enviar
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      email: String,
      tipoStatus: Array,
      comentarios: String,
      status: String,
      ifCancelada: Function,
      updateStatusImp: Function
    },
    data() {
      return {
        localStatus: this.status,
        localEmail: this.email,
        localComentarios: this.comentarios
      };
    },
    methods: {
      closeModal() {
        this.$modal.hide('estatus-importacion');
      },
      updateStatus() {
        this.$emit('update:status', this.localStatus);
        this.ifCancelada();
      },
      updateEmail() {
        this.$emit('update:email', this.localEmail);
      },
      updateComentarios() {
        this.$emit('update:comentarios', this.localComentarios);
      }
    },
    watch: {
      status(newVal) {
        this.localStatus = newVal;
      },
      email(newVal) {
        this.localEmail = newVal;
      },
      comentarios(newVal) {
        this.localComentarios = newVal;
      }
    }
  };
  </script>
  